// Diagrama eléctrico publicado para el visor.
//
// El administrador sube desde el panel el .json que exporta el editor de
// diagramas (diagrama-rocharamas → Proyecto → Exportar). Queda en Storage en
// RUTA_DIAGRAMA y el visor lo abre por defecto, sin iniciar sesión.
export const RUTA_DIAGRAMA = 'diagramas/actual.json';

// Dirección pública del visor, para mostrar el enlace en el panel.
// Déjala vacía hasta que el visor esté publicado en algún dominio.
export const URL_VISOR_DIAGRAMA = '';
